import { useState, useEffect } from 'react'
import { useDebounce } from 'lib/hooks'
import DrawerModal from 'components/modal/drawer-modal'
import { getLocation } from '../helpers'
import SearchInput from './search-input'
import SearchModalTrigger from './search-modal-trigger'
import SearchSuggestions from './search-suggestions'
import SearchHistory from './search-history'
import css from '../store-search.scss'

const SearchModal = () => {
  const [listFocus, setListFocus] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const [searchString, setSearchString] = useState('')
  const suggestionTerm = useDebounce(searchString, 500)
  const { pathname, search } = getLocation()

  const closeModal = () => {
    setShowModal(false)
    setListFocus(false)
  }

  // close modal on navigation
  useEffect(() => {
    closeModal()
  }, [pathname, search])

  const onSearch = (newSearchString) => {
    setSearchString(newSearchString)
  }

  const onKeyDown = ({ key }) => {
    if (!listFocus && key === 'ArrowDown') {
      setListFocus(true)
    }
  }

  return (
    <div className="container">
      <DrawerModal
        show={showModal}
        style={{ minHeight: 370, maxHeight: 405 }} // Setting a max height of 405px to accomodate the RegistryBanner if shown
        trigger={
          <SearchModalTrigger
            value={searchString}
            onClick={() => setShowModal(true)}
          />
        }
        onHide={closeModal}
      >
        <SearchInput
          closeModal={closeModal}
          inFocus={!listFocus}
          searchString={searchString}
          setSearchString={setSearchString}
          onKeyDown={onKeyDown}
        />

        <div className={`container ${css.suggestionsContainer}`}>
          {suggestionTerm && searchString.length >= 2 ? (
            <SearchSuggestions
              inFocus={listFocus}
              searchString={searchString}
              suggestionTerm={suggestionTerm.trim()}
              onBlur={() => setListFocus(false)}
              onSearch={onSearch}
            />
          ) : (
            <SearchHistory
              inFocus={listFocus}
              onBlur={() => setListFocus(false)}
              onSearch={onSearch}
            />
          )}
        </div>
      </DrawerModal>
    </div>
  )
}

export default SearchModal
